import React, { lazy } from 'react'

// const BankEFTListing = lazy(() =>
//   import('./BankEFTListing').then(module => ({
//     default: module.BankEFTListing,
//   }))
// )

export const paymentMethodRoutes = [
  {
    props: {
      exact: true,
      path: '/bank-eft',
    },
    // component: <BankEFTListing />,
  },
]

export default paymentMethodRoutes
